export const embedURL = (url: string) => {
  const root = "https://iframe.ly/api/iframely"
  const key = "b8a640388fb50cfa2f18b0"
  const query = `${root}?url=${url}&api_key=${key}&omit_script=true&iframe=true`

  return new Promise((resolve, reject) => {
    fetch(query)
      .then((res) => res.json())
      .then((res) => {
        if (res.error) {
          reject(res.error)
        } else {
          resolve(res)
        }
      })
      .catch((err) => {
        reject(new Error(err))
      })
  })
}

// Replace 'iframe.ly' with your custom CDN if available.
export const loadIframely = () => {
  const iframely = ((window as any).iframely = (window as any).iframely || {})
  const widgets = (iframely.widgets = iframely.widgets || {})
  if (widgets.load) {
    widgets.load()
  } else {
    const ifs = document.createElement("script")
    ifs.type = "text/javascript"
    ifs.async = true
    ifs.src =
      ("https:" === document.location.protocol ? "https:" : "http:") +
      "//cdn.iframe.ly/embed.js"
    const s = document.getElementsByTagName("script")[0]
    s?.parentNode?.insertBefore(ifs, s)
  }
  return true
}
